"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withComplexWidgetHoverManager = void 0;
var lodash_1 = require("lodash");
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var react_1 = __importDefault(require("react"));
var euclidianDistance = function (a, b) { return Math.sqrt(Math.pow(a.x - b.x, 2) + Math.pow(a.y - b.y, 2)); };
var withComplexWidgetHoverManager = function (WrappedComponent) {
    var MOUSE_MOVE_THRESHOLD = 20;
    var HOVER_DELAY = 80;
    var WithWidgetHoverManager = (function (_super) {
        __extends(WithWidgetHoverManager, _super);
        function WithWidgetHoverManager(props) {
            var _this = _super.call(this, props) || this;
            _this.hoverStateSuppressed = false;
            _this.isHovered = false;
            _this.mouseMoveStartCoordinates = undefined;
            _this.handleHover = function (newValue) {
                _this.isHovered = newValue;
            };
            _this.handleDocumentMouseMove = function (event) {
                var mouseMoveStartCoordinates = _this.mouseMoveStartCoordinates;
                if (!mouseMoveStartCoordinates) {
                    _this.hoverStateSuppressed = false;
                }
                else if (event.buttons === 0) {
                    var mouseLocation = { x: event.clientX, y: event.clientY };
                    var distanceMoved = euclidianDistance(mouseMoveStartCoordinates, mouseLocation);
                    if (distanceMoved > MOUSE_MOVE_THRESHOLD) {
                        _this.hoverStateSuppressed = false;
                    }
                }
            };
            _this.handleDocumentMouseDown = function (event) {
                _this.hoverStateSuppressed = true;
                var clientX = event.clientX, clientY = event.clientY;
                _this.mouseMoveStartCoordinates = {
                    x: clientX,
                    y: clientY,
                };
            };
            _this.handleDocumentKeyDown = function () {
                _this.hoverStateSuppressed = true;
                _this.mouseMoveStartCoordinates = undefined;
            };
            _this.debouncedHoverHandler = (0, lodash_1.debounce)(_this.handleHover, HOVER_DELAY, { leading: true });
            return _this;
        }
        WithWidgetHoverManager.prototype.componentDidMount = function () {
            document.addEventListener("mousemove", this.handleDocumentMouseMove);
            document.addEventListener("keydown", this.handleDocumentKeyDown);
            document.addEventListener("mousedown", this.handleDocumentMouseDown);
        };
        WithWidgetHoverManager.prototype.componentWillUnmount = function () {
            document.removeEventListener("mousemove", this.handleDocumentMouseMove);
            document.removeEventListener("keydown", this.handleDocumentKeyDown);
            document.removeEventListener("mousedown", this.handleDocumentMouseDown);
        };
        Object.defineProperty(WithWidgetHoverManager.prototype, "hoverManager", {
            get: function () {
                var _this = this;
                return {
                    isHovered: !this.hoverStateSuppressed && this.isHovered,
                    handlers: {
                        onMouseEnter: function () { return _this.debouncedHoverHandler(true); },
                        onMouseLeave: function () { return _this.debouncedHoverHandler(false); },
                        onMouseMove: function () { return _this.debouncedHoverHandler(true); },
                    },
                };
            },
            enumerable: false,
            configurable: true
        });
        WithWidgetHoverManager.prototype.render = function () {
            return react_1.default.createElement(WrappedComponent, __assign({}, this.props, { hoverManager: this.hoverManager }));
        };
        __decorate([
            mobx_1.observable.ref,
            __metadata("design:type", Object)
        ], WithWidgetHoverManager.prototype, "hoverStateSuppressed", void 0);
        __decorate([
            mobx_1.observable.ref,
            __metadata("design:type", Object)
        ], WithWidgetHoverManager.prototype, "isHovered", void 0);
        __decorate([
            mobx_1.action,
            __metadata("design:type", Object)
        ], WithWidgetHoverManager.prototype, "handleHover", void 0);
        __decorate([
            mobx_1.action,
            __metadata("design:type", Object)
        ], WithWidgetHoverManager.prototype, "handleDocumentMouseMove", void 0);
        __decorate([
            mobx_1.action,
            __metadata("design:type", Object)
        ], WithWidgetHoverManager.prototype, "handleDocumentMouseDown", void 0);
        __decorate([
            mobx_1.action,
            __metadata("design:type", Object)
        ], WithWidgetHoverManager.prototype, "handleDocumentKeyDown", void 0);
        __decorate([
            mobx_1.computed,
            __metadata("design:type", Object),
            __metadata("design:paramtypes", [])
        ], WithWidgetHoverManager.prototype, "hoverManager", null);
        WithWidgetHoverManager = __decorate([
            mobx_react_1.observer,
            __metadata("design:paramtypes", [Object])
        ], WithWidgetHoverManager);
        return WithWidgetHoverManager;
    }(react_1.default.Component));
    return WithWidgetHoverManager;
};
exports.withComplexWidgetHoverManager = withComplexWidgetHoverManager;
